import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SizeChartModal } from "@faire/retailer-visitor-shared/views/product/ProductDetails/AddToCart/OptionSelection/SizeChartModal";
import { trackEvent } from "@faire/web--source/common/trackEvent";
import { Button } from "@faire/web--source/slate/Button";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { observer } from "mobx-react";
import React, { useState } from "react";
var SizeChartLinkFn = function(param) {
    var brand = param.brand, product = param.product;
    var _brand_brand_size_chart;
    var _useState = _sliced_to_array(useState(false), 2), showSizeChartModal = _useState[0], setShowSizeChartModal = _useState[1];
    var onOpen = function() {
        setShowSizeChartModal(true);
        trackEvent("/size-chart-modal/".concat(brand.token, "/").concat(product.token));
    };
    if (!((_brand_brand_size_chart = brand.brand_size_chart) === null || _brand_brand_size_chart === void 0 ? void 0 : _brand_brand_size_chart.url)) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                align: "right",
                children: /*#__PURE__*/ _jsx(Button, {
                    variant: "tertiary",
                    onClick: onOpen,
                    style: {
                        whiteSpace: "nowrap"
                    },
                    "data-test-id": "product-size-chart-link",
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "bTcfiq",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Size Chart"
                            }
                        ]
                    })
                })
            }),
            showSizeChartModal ? /*#__PURE__*/ _jsx(SizeChartModal, {
                brand: brand,
                product: product,
                onClose: function() {
                    return setShowSizeChartModal(false);
                }
            }) : null
        ]
    });
};
export var SizeChartLink = observer(SizeChartLinkFn);
